import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { connect } from 'react-redux';
import { login } from '../redux/reduxActions/actions';

function Login(props) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const loginUser = () => {
    props.login({ email, password });
  };
  return (
    <div className="login-form">
      <Form>
        <Form.Group controlId="formBasicEmail">
          <Form.Label>Email address</Form.Label>
          <Form.Control onChange={(e) => { setEmail(e.target.value); }} type="email" placeholder="Enter email" />
        </Form.Group>

        <Form.Group controlId="formBasicPassword">
          <Form.Label>Password</Form.Label>
          <Form.Control onChange={(e) => { setPassword(e.target.value); }} type="password" placeholder="Password" />
        </Form.Group>
      </Form>
      <Button onClick={() => loginUser()} variant="primary" type="submit">
        Submit
      </Button>
    </div>
  );
}

export default connect(() => {}, { login })(Login);
